// Copy-pasted from here https://github.com/strapi/strapi-examples/blob/master/login-react/react-login-front-end-app/app/containers/ProtectedRoute/index.js

import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import auth from '../utils/auth';

const ProtectedRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    !!localStorage.getItem('access_token') ? (
      <Component {...props} />
    ) : (
      <Redirect to={{
        pathname: 'login',
        state: { from: props.location }
        }}
      />
    )
  )} />
);

export default ProtectedRoute;